"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var ResponsiveResizeComponent_1 = require("../base/ResponsiveResizeComponent");
var floatMarker_1 = require("../floatMarker");
var icon_1 = require("../icon");
var Tabs = /** @class */ (function (_super) {
    tslib_1.__extends(Tabs, _super);
    function Tabs(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.markSelectedButton = function () {
            var _a = _this.props, theme = _a.theme, active = _a.active;
            if (!active) {
                return;
            }
            var activeButton = _this.$tabs.querySelector("." + theme.active);
            if (!activeButton) {
                return;
            }
            utils_1.raf(function () {
                if (_this.willUnmount) {
                    return;
                }
                var offsetLeft = activeButton.offsetLeft;
                var rect = activeButton.getBoundingClientRect();
                _this.setState({
                    markerLeft: offsetLeft,
                    markerWidth: rect.width
                });
            });
        };
        _this.onTabClick = function (name, hash) {
            var _a = _this.props, onChange = _a.onChange, active = _a.active;
            if (name !== active) {
                onChange(name);
            }
            if (hash && window.location.hash !== "#" + hash) {
                window.location.hash = hash;
            }
        };
        _this.setRef = function (el) {
            _this.$tabs = el;
        };
        _this.setMainRef = function (el) {
            _this.el = el;
        };
        _this.setRightArrowRef = function (el) {
            _this.rightArrow = el;
        };
        _this.setLeftArrowRef = function (el) {
            _this.leftArrow = el;
        };
        _this.onHoverRight = function () {
            var scrollJump = _this.props.scrollJump;
            _this.sideScroll(_this.$tabs, "right", 10, scrollJump, 10);
        };
        _this.onHoverLeft = function () {
            var scrollJump = _this.props.scrollJump;
            _this.sideScroll(_this.$tabs, "left", 10, scrollJump, 10);
        };
        _this.onClickRight = function () {
            _this.sideScroll(_this.$tabs, "right", 15, 500, 10);
        };
        _this.onClickLeft = function () {
            _this.sideScroll(_this.$tabs, "left", 15, 500, 10);
        };
        _this.sideScroll = function (element, direction, time, distance, step) {
            if (distance === void 0) { distance = 110; }
            var scrollAmount = 0;
            var slideTimer = setInterval(function () {
                if (direction === "left") {
                    element.scrollLeft -= step;
                }
                else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if (scrollAmount >= distance) {
                    // @ts-ignore
                    window.clearInterval(slideTimer);
                }
            }, time);
        };
        _this.onScroll = function () {
            var navBarHeight = 68;
            utils_1.raf(function () {
                if (_this.el) {
                    var top_1 = _this.el.getBoundingClientRect().top;
                    var parentDepth = 3;
                    var element = _this.el;
                    for (var i = 0; i < parentDepth; i++) {
                        element = element.parentElement;
                    }
                    var stickyElement = element.firstChild;
                    if (!stickyElement || !(stickyElement instanceof HTMLElement)) {
                        return;
                    }
                    var stickyElementHeight = stickyElement.clientHeight;
                    var value_1 = stickyElementHeight + navBarHeight;
                    if (top_1 <= value_1) {
                        if (!_this.state.isSticky) {
                            _this.setState({ isSticky: true }, function () {
                                _this.el.style.backgroundColor = _this.props.stickyBackgroundColor || "var(--primary-container-body-color)";
                                _this.el.style.top = String(value_1 + "px");
                            });
                        }
                    }
                    else {
                        if (_this.state.isSticky) {
                            _this.setState({ isSticky: false }, function () {
                                _this.el.style.backgroundColor = "transparent";
                                _this.el.style.top = "0";
                            });
                        }
                    }
                }
            });
        };
        _this.state = { markerLeft: 0, markerWidth: 0, isSticky: false };
        _this.$tabs = null;
        _this.willUnmount = false;
        _this.el = null;
        _this.leftArrow = null;
        _this.rightArrow = null;
        _this.originalWidths = null;
        _this.totalWidth = null;
        _this.isScrolling = false;
        _this.calcMoreItems = _this.calcMoreItems.bind(_this);
        return _this;
    }
    Tabs.prototype.getChildContext = function () {
        return {
            onTabClick: this.onTabClick,
            activeTabName: this.props.active,
            onLayoutChanged: this.markSelectedButton
        };
    };
    Tabs.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.markSelectedButton();
        var $list = this.el.querySelectorAll("button");
        if ($list) {
            var items = utils_1.nodeListToArrayOf($list);
            this.originalWidths = items.map(function (child) { return child.getBoundingClientRect().width; });
            this.totalWidth = this.originalWidths.reduce(function (r, c) { return r + c; }, 0) + items.length * 20 + (items.length - 2) * 20;
            this.calcMoreItems();
            this.props.sticky && this.onScroll();
        }
        window.addEventListener("resize", this.calcMoreItems, false);
        if (this.props.sticky) {
            window.addEventListener("scroll", this.onScroll);
        }
    };
    Tabs.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.willUnmount = true;
        window.removeEventListener("resize", this.calcMoreItems, false);
    };
    Tabs.prototype.componentDidResize = function (e) {
        this.markSelectedButton();
    };
    Tabs.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.active !== this.props.active) {
            this.markSelectedButton();
        }
    };
    Tabs.prototype.calcMoreItems = function () {
        var _this = this;
        utils_1.raf(function () {
            if (_this.el) {
                var innerWidth_1 = _this.el.getBoundingClientRect().width;
                if (innerWidth_1 > _this.totalWidth || innerWidth_1 === 0) {
                    return;
                }
                _this.rightArrow.style.display = "block";
                _this.leftArrow.style.display = "block";
            }
        });
    };
    Tabs.prototype.render = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, className = _c.className, theme = _c.theme, onChange = _c.onChange, active = _c.active, middle = _c.middle, truncate = _c.truncate, others = tslib_1.__rest(_c, ["children", "className", "theme", "onChange", "active", "middle", "truncate"]);
        var _d = this.state, left = _d.markerLeft, width = _d.markerWidth;
        var classes = classnames_1.default(theme.tabs, className, (_a = {},
            _a[theme.active] = active,
            _a[theme.middle] = middle,
            _a[theme.truncate] = truncate,
            _a));
        var classesLeft = classnames_1.default(theme.arrow, theme.leftArrow);
        var classesRight = classnames_1.default(theme.arrow, theme.rightArrow);
        var mainTabsClasses = classnames_1.default(theme.mainTabs, (_b = {},
            _b[theme.sticky] = this.state.isSticky,
            _b));
        return (React.createElement("div", { className: mainTabsClasses, ref: this.setMainRef },
            React.createElement("div", { className: classesLeft, ref: this.setLeftArrowRef, onMouseOver: this.onHoverLeft, onClick: this.onClickLeft },
                React.createElement(icon_1.default, { iconName: "icon-arrow-left-small", size: 1.2, iconColor: "var(--tab-color)" })),
            React.createElement("div", { className: classes, ref: this.setRef },
                React.createElement("div", { className: theme.inner },
                    active ? (React.createElement(floatMarker_1.FloatMarker, { className: theme.marker, width: width, left: left })) : null,
                    children)),
            React.createElement("div", { className: classesRight, ref: this.setRightArrowRef, onMouseOver: this.onHoverRight, onClick: this.onClickRight },
                React.createElement(icon_1.default, { iconName: "icon-arrow-right-small", size: 1.2, iconColor: "var(--tab-color)" }))));
    };
    Tabs.defaultProps = {
        onChange: utils_1.noop,
        middle: false,
        truncate: true
    };
    Tabs.childContextTypes = {
        onTabClick: PropTypes.func,
        activeTabName: PropTypes.string,
        onLayoutChanged: PropTypes.func
    };
    return Tabs;
}(ResponsiveResizeComponent_1.default));
exports.default = Tabs;
